import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
// import "../library.css";
import { API_BASE_URL } from '../../../configs/AppConfig';
// import { FILES_URL } from '../../../configs/AppConfig';
import { jwtDecode } from "jwt-decode";
import { message } from 'antd';
import CustomDropdown from "../../../components/SchoolsDropdown";
import { FileUploader } from 'react-drag-drop-files';
import Loader from "components/loader";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";


const fileTypes = ["xlsx", "xls", "csv", "pptx", "ppt"];
const MAX_SIZE = 10 * 1024 * 1024; // 10MB


const AccountsManagement = () => {

    const [current , setCurrent] = useState("schools");
    const [preLoading, setPreLoading] = useState(false);
    const [excel, setExcel] = useState(null)
    console.log("excel ", excel)
    const [formInputs , setFormInputs] = useState({
              printerId:"",
              schoolName:"",
              schoolAddress:"",
              schoolPhone:"",
              schoolId:"",
            });
    const [schoolsData, setSchoolsData] = useState([]);
    
    const isFormSchoolValid = formInputs.schoolName.trim() !== '' && formInputs.schoolAddress.trim() !== '' 
    && formInputs.schoolPhone.trim() !== '';

    const isFormTeacherValid = formInputs.schoolId !== '' && excel !== null;

    const isFormPrinterValid = formInputs.schoolId !== '' && formInputs.printerId.trim() !== '';

    const sizeMessage = () => {
           message.error('File size exceeds the limit of 10MB');
          }

useEffect(() => {
     api.get(`${API_BASE_URL}school`)
      .then((response) => {  
        setSchoolsData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, []);

    const currentChange= ()=>{
                    setExcel(null);
                    setFormInputs(prev => ({...prev, schoolId: "",schoolName: "", printerId:"", schoolAddress:"", schoolPhone:""}));

                }
 const newSchool = (e)=>{
  setFormInputs({...formInputs, schoolId: e.id, schoolName: e.name})
}

  
const submitSchool = async (event) => {
      event.preventDefault();
  try {
    const response = await api.post(`${API_BASE_URL}school`, {
      name: formInputs.schoolName,
      address: formInputs.schoolAddress,
      phone: formInputs.schoolPhone
    });

    console.log(response.data);
    setSchoolsData(response.data); // Update the schoolsData state with the new school
    message.success('School Added Successfully');

setFormInputs(prev => ({
  ...prev,
  schoolName: "",
  schoolAddress: "",
  schoolPhone: ""
}));
    } catch (error) {
    console.log("handlesubmit error for school ", error);
    message.error(error.response?.data?.message || 'Failed to add school ❌');
  }
};
    const handelsubmit = async (event) => {
        event.preventDefault();
          setPreLoading(true);
          if (current === "teachers") {
            submitTeacher();
          }
          else if (current === "students") {
             submitStudent();
          }
              }

    const submitPrinter = async (event) => {
           event.preventDefault();
        try {
          const response = await api.post(`${API_BASE_URL}printer/add`, {
            printerId: formInputs.printerId,
            schoolId: formInputs.schoolId,
          });

          console.log(response.data);
          message.success('Printer Added Successfully');

      setFormInputs(prev => ({
        ...prev,
        printerId: "",
        schoolId: "",
        schoolName: "",
      }));
          } catch (error) {
          console.log("handlesubmit error for printer ", error);
          message.error(error.response?.data?.message || 'Failed to add printer ❌');
        }
              }

  const submitStudent = async () => {
        if (excel.size > MAX_SIZE) {
          sizeMessage();
          return;
          }

          const formData = new FormData();
            formData.append('file', excel);   // ← changed from 'pptx'
            await api.post(`${API_BASE_URL}student/bulk-upload?schoolId=${formInputs.schoolId}`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                  console.log("handlesubmitffff  ", response.data)
                                  message.success(
                                    // `inserted : ${response.data.inserted} , skippedExisting : ${response.data.skippedExisting}
                                    // skippedEmails : ${response.data.skippedEmails}` || 
                                    'Students Added Successfully');
                                  setPreLoading(false);
                                  setExcel(null);
                                  setFormInputs(prev => ({
                                    ...prev,
                                    schoolId: "",
                                    schoolName: ""
                                  }));
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                              message.error(error.response?.data?.message || 'Failed to add students ❌');
                                  setPreLoading(false);
                                  setExcel(null);
                                  setFormInputs(prev => ({
                                    ...prev,
                                    schoolId: "",
                                    schoolName: ""
                                  }));
                            });
  }

  const submitTeacher = async () => {
        if (excel.size > MAX_SIZE) {
          sizeMessage();
          return;
          }

          const formData = new FormData();
            formData.append('file', excel);   // ← changed from 'pptx'
            await api.post(`${API_BASE_URL}teacher/bulk-upload?schoolId=${formInputs.schoolId}`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                  console.log("handlesubmitffff  ", response.data)
                                  message.success(
                                    // `inserted : ${response.data.inserted} , skippedExisting : ${response.data.skippedExisting}
                                    // skippedEmails : ${response.data.skippedEmails}` || 
                                    'Teachers Added Successfully');
                                  setPreLoading(false);
                                  setExcel(null);
                                  setFormInputs(prev => ({
                                    ...prev,
                                    schoolId: "",
                                    schoolName: ""
                                  }));
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                              message.error(error.response?.data?.message || 'Failed to add teachers ❌');
                                  setPreLoading(false);
                                  setExcel(null);
                                  setFormInputs(prev => ({
                                    ...prev,
                                    schoolId: "",
                                    schoolName: ""
                                  }));
                            });
  } 

const schools = () => {
  return ( <form className="addChallenge mb-[100px]" onSubmit={submitSchool}>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
          <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label htmlFor="schoolName">School name</label>
            <input type="text" className="inputWidth" id="schoolName" value={formInputs.schoolName} placeholder="Enter School name" 
            onChange={(e) =>setFormInputs({...formInputs, schoolName: e.target.value})}/>
          </div>
            <div className="addCHInpts">
            <label htmlFor="schoolAddress">School address</label>
            <input type="text" className="inputWidth" id="schoolAddress" value={formInputs.schoolAddress} placeholder="Enter School address"
             onChange={(e) =>setFormInputs({...formInputs, schoolAddress: e.target.value})}/>
           </div>
        </div>
          <div className="addChallengeLR">
          <div className="addCHInpts">
            <label htmlFor="schoolPhone">School phone number</label>
            <input type="text" className="inputWidth" id="schoolPhone" value={formInputs.schoolPhone} placeholder="Enter School phone"
             onChange={(e) =>setFormInputs({...formInputs, schoolPhone: e.target.value})}/>
          </div>
    </div>   
        </div>
        <div style={{textAlign:"center"}}>
<button
  type="submit"
  disabled={!isFormSchoolValid}
  className={`add-Challenge ${!isFormSchoolValid ? "opacity-50 cursor-not-allowed" : ""}`}
>
  Add School
</button>
        </div>
       </form> 

  );
}
const teachersAndStudents = () => {
  return ( <form className="addChallenge mb-[100px]" onSubmit={handelsubmit}>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
      <div className="addCHInpts">
        <label for="school">Schools</label>
      <CustomDropdown options={schoolsData}
       selectedd={newSchool}
       type="Select School"
       schoolId={formInputs.schoolId}
       schoolName={formInputs.schoolName}
       />
      </div>
        </div>
          <div className="addChallengeLR">
        <h4 className="trAttachment"> Excel File </h4>
        <div className="trAttachmentDev mrAtt flex">
        <FileUploader handleChange={(file) => setExcel(file)} name="file" types={fileTypes}  fileOrFiles={excel} />
          <Loader loading={preLoading} />
           {excel && !preLoading ? <IoCheckmarkDoneCircleSharp style={{ width: '45px', height: '45px', marginLeft: '10px', color: 'green' }}/> : null}
        </div>    </div>   
        </div>
        <div style={{textAlign:"center"}}>
{current === "teachers" ? (
  <button
    type="submit"
    disabled={!isFormTeacherValid}
    className={`add-Challenge ${!isFormTeacherValid ? "opacity-50 cursor-not-allowed" : ""}`}
  >
    Upload Teachers
  </button>
) : (
<button
  type="submit"
  disabled={!isFormTeacherValid}
  className={`add-Challenge ${!isFormTeacherValid ? "opacity-50 cursor-not-allowed" : ""}`}
>
  Upload Students
</button>)
}

        </div>
       </form> 

  );
}

const printers = () => {
  return ( <form className="addChallenge mb-[100px]" onSubmit={submitPrinter}>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
      <div className="addCHInpts">
        <label for="school">Schools</label>
      <CustomDropdown options={schoolsData}
       selectedd={newSchool}
       type="Select School"
       schoolId={formInputs.schoolId}
       schoolName={formInputs.schoolName}
       />
      </div>
        </div>
          <div className="addChallengeLR">
        <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label htmlFor="printerId">Printer ID</label>
            <input type="text" className="inputWidth" id="printerId" value={formInputs.printerId} placeholder="Enter Printer ID" 
            onChange={(e) =>setFormInputs({...formInputs, printerId: e.target.value})}/>
          </div> </div>   
        </div>
        <div style={{textAlign:"center"}}>

  <button
    type="submit"
    disabled={!isFormPrinterValid}
    className={`add-Challenge ${!isFormPrinterValid ? "opacity-50 cursor-not-allowed" : ""}`}
  >
    Add Printer
  </button>
        </div>
       </form> 

  );
}
  return (
      <div className="h-fit w-full">
        <div className="libraryHeader">
          <div className="libraryH">
          <h1>Accounts Management</h1>
  <div className="flex flex-row gap-[10px] text-[18px] font-[600]"> 
    <div className="headerLink" onClick={() => {setCurrent("schools") 
      currentChange()
    }} >
             <span className={current==="schools" ? "active" : "noActive"}>Schools</span>
           </div>
            <div className="headerLink" onClick={() => {
              setCurrent("teachers");
              currentChange();
            }} >
             <span className={current==="teachers" ? "active" : "noActive"}>Teachers</span>
           </div>
            <div className="headerLink" onClick={() => {
              setCurrent("students");
              currentChange();
            }} >
             <span className={current==="students" ? "active" : "noActive"}>Students</span>
           </div>
          <div className="headerLink" onClick={() => {
              setCurrent("printers");
              currentChange();
            }} >
             <span className={current==="printers" ? "active" : "noActive"}>Printers</span>
           </div>
          </div>  
          </div>
          <div className="libraryheaderImg"></div>
        </div>
        {/* library cards */}
        {current === "schools" ? schools() : null }
        {current === "teachers" || current === "students" ? teachersAndStudents() : null }
        {current === "printers" ? printers() : null }

      </div>      
  );
};

export default AccountsManagement;
